var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.9375C8.84619 9.9375 9.9375 8.84619 9.9375 7.5C9.9375 6.15381 8.84619 5.0625 7.5 5.0625C6.15381 5.0625 5.0625 6.15381 5.0625 7.5C5.0625 8.84619 6.15381 9.9375 7.5 9.9375Z",
    stroke: "#1E3799",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1C5.77609 1 4.12279 1.68482 2.90381 2.90381C1.68482 4.12279 1 5.77609 1 7.5C1 9.03725 1.32662 10.0431 2.21875 11.1562L7.5 17.25L12.7812 11.1562C13.6734 10.0431 14 9.03725 14 7.5C14 5.77609 13.3152 4.12279 12.0962 2.90381C10.8772 1.68482 9.22391 1 7.5 1V1Z",
    stroke: "#1E3799",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationBlue);
export default __webpack_public_path__ + "static/media/icon_location_blue.998d739f1e94f3b9e8d1196b70d6a7ed.svg";
export { ForwardRef as ReactComponent };